import * as marietta from '../..';
import * as digifie from '../../../digifie';

import { WalkThroughCameraControl, Config, defines } from './index';

/* ControlUI
 * UIコントローラー.
 */
export class ControlUI {
  constructor() {
  }

  public draw() { /* do nothing */ }

  public set visible(vis: boolean) { /* do nothing */ }

  public get visible(): boolean { return true; }
}

/* ControlButton
 * カメラナビゲーションボタン.
 */
export class ControlButton extends ControlUI {
    _instance: digifie.items.ControlButton;

    public get me(): digifie.items.ControlButton { return this._instance; }

    public set me(i: digifie.items.ControlButton) { this._instance = i; }

    public set visible(vis: boolean) { this.me.visible(vis); }

    public draw() { }

    constructor(id: string, right: number, bottom: number, imgSrc: string, container: HTMLElement, control: WalkThroughCameraControl) {
      super();

      this.me = new digifie.items.ControlButton(id, right, bottom, imgSrc, container, control.me);
    }
}

/* ControlUIGruop
 * UIコントローラーグループ.
 */
export enum PosOrigin {
    LeftTop,
    LeftBottom,
    RightTop,
    RightBottom,
}

/**
 * class: ControlUIGruop
 */
export class ControlUIGruop {
    private _parent: HTMLElement;

    protected _controls: Array<ControlButton>;

    protected _visible: boolean;

    protected _container: HTMLElement;

    constructor(id: string, origin: PosOrigin, pos_x: number, pos_y: number, container: HTMLElement) {
      this._parent = container;
      if ((container != undefined) && (typeof document !== 'undefined')) {
        this._container = document.createElement(id);
        this._container.id = id;
        this._container.style.position = 'fixed';
        this._container.style.background = '#00ffff';
        this._container.style.padding = '0';
        this._container.style.margin = '0';
        this._container.style.width = '0px';
        this._container.style.height = '0px';
        this._container.style.opacity = '1';

        if (origin === PosOrigin.LeftBottom) {
          this._container.style.left = `${pos_x}px`;
          this._container.style.bottom = `${pos_y}px`;
        } else if (origin === PosOrigin.RightTop) {
          this._container.style.right = `${pos_x}px`;
          this._container.style.top = `${pos_y}px`;
        } else if (origin === PosOrigin.RightBottom) {
          this._container.style.right = `${pos_x}px`;
          this._container.style.bottom = `${pos_y}px`;
        } else {
          this._container.style.left = `${pos_x}px`;
          this._container.style.top = `${pos_y}px`;
        }
        this._parent.appendChild(this._container);
        this._visible = true;
        this._controls = new Array<ControlButton>();
      } else {
        this._visible = false;
        this._controls = new Array<ControlButton>();
      }
    }

    public draw() { }

    protected makeVisible(vis: boolean) {
      if (this._container == undefined) return;

      for (let i = 0; i < this._controls.length; i++) {
        this._controls[i].visible = vis;
      }
      if (vis) this._container.style.visibility = '';
      else this._container.style.visibility = 'hidden';
      this._visible = vis;
    }

    public set visible(vis: boolean) {
      this.makeVisible(vis);
    }

    public get visible(): boolean { return this._visible; }

    public append(ctrl: ControlButton) {
      this._controls.push(ctrl);
      ctrl.visible = this._visible;
    }
}

/* CameraControls
 * カメラナビゲーションボタン.
 */
export class CameraControls extends ControlUIGruop {
    private _control: WalkThroughCameraControl;

    private _mode: defines.WtCamCtrlMode;

    constructor(id: string, origin: PosOrigin, pos_x: number, pos_y: number, container: HTMLElement, control: WalkThroughCameraControl) {
      super(id, origin, pos_x, pos_y, container);

      this._control = control;
      this._mode = defines.WtCamCtrlMode.wtButtons;
      this.add_controls();
    }

    public add_controls(): void {
      const bPad = Config.me.isTouchMode(this._container);
      this.append(new ControlButton('bt_up', (bPad ? 65 : 58), (bPad ? 210 : 176), marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + (bPad ? 'move_forward_pad.png?2' : 'move_forward.png'), this._container, this._control));
      this.append(new ControlButton('bt_down', (bPad ? 65 : 50), (bPad ? 88 : 75), marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + (bPad ? 'move_back_pad.png?2' : 'move_back.png'), this._container, this._control));
      this.append(new ControlButton('bt_left', (bPad ? 177 : 169), (bPad ? 165 : 136), marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + (bPad ? 'look_left_pad.png?2' : 'look_left.png'), this._container, this._control));
      this.append(new ControlButton('bt_right', (bPad ? 26 : 15), (bPad ? 165 : 136), marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + (bPad ? 'look_right_pad.png?2' : 'look_right.png'), this._container, this._control));
      this.append(new ControlButton('bt_home', (bPad ? 95 : 84), (bPad ? 173 : 149), marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + (bPad ? 'set_default_pad.png?2' : 'set_default.png'), this._container, this._control));
    }

    public set visible(vis: boolean) {
      if (this._control.me.padEnabled()) {
        this.makeVisible(false);
        this._control.me.showPad(vis);
      } else {
        this.makeVisible(vis);
      }
    }

    protected makeVisible(vis: boolean): void {
      if (!vis) {
        super.makeVisible(vis);
        return;
      }

      if (this._container == undefined) return;
      this._controls[0].visible = vis;
      this._controls[4].visible = vis;
      const bPad = Config.me.isTouchMode(this._container);
      if (this._mode == defines.WtCamCtrlMode.wtButtons) {
        (this._controls[0]).me.moveControl((bPad ? 65 : 58), (bPad ? 210 : 176));
        (this._controls[4]).me.moveControl((bPad ? 95 : 84), (bPad ? 173 : 149));
        this._controls[1].visible = vis;
        this._controls[2].visible = vis;
        this._controls[3].visible = vis;
      } else {
        (this._controls[0]).me.moveControl((bPad ? 65 : 58), (bPad ? 166 : 126));
        (this._controls[4]).me.moveControl((bPad ? 95 : 84), (bPad ? 123 : 99));
        this._controls[1].visible = false;
        this._controls[2].visible = false;
        this._controls[3].visible = false;
      }
      this._container.style.visibility = '';

      this._visible = vis;
    }

    public set mode(mode: defines.WtCamCtrlMode) {
      this._mode = mode;
      this.makeVisible(this._visible);
    }
}
